export default {
  namespaced: true,
  state: {
    userAccountTypes: [
      {
        value: 'PERSONAL',
        text: 'Personal',
        label: 'Personal',
      },
      {
        value: 'COMPANY',
        text: 'Company',
        label: 'Company',
      },
    ],
  },
  getters: {},
  mutations: {},
  actions: {},
}
